import React, { Component } from "react";
import { Link } from "react-router-dom";
import Logo from "../../assets/images/actl_logo.gif";

const NAV_ITEMS = [
  {
    label: "Legacy Services",
    href: "/it-consulting-services",
    children: [
      { label: "IT Consulting Services", href: "/it-consulting-services" },
      { label: "Managed Services", href: "/services/managed-services" },
      { label: "Dedicated Engineering Teams", href: "/services/dedicated-engineering-teams" },
      { label: "Legacy Modernization", href: "/services/legacy-modernization" },
      { label: "Enterprise AI Enablement", href: "/services/enterprise-ai-enablement" },
      { label: "Quality Assurance", href: "/quality-assurance" },
      { label: "Microsoft Technologies", href: "/microsoft-technologies" },
      { label: "Java Development", href: "/java-development" },
      { label: "Design Suite", href: "/design-suite" },
      { label: "Project Management", href: "/project-management" },
    ],
  },
  {
    label: "Industry Verticals",
    href: "/travel-hospitality",
    children: [
      { label: "Travel & Hospitality", href: "/travel-hospitality" },
      { label: "Healthcare", href: "/healthcare" },
      { label: "Insurance", href: "/insurance" },
      { label: "Legal", href: "/legal" },
    ],
  },
  {
    label: "Products & Platforms",
    href: "/it-consulting-services",
    children: [
      { label: "DXchange — API Management", href: "/dxchange" },
      { label: "DotNetNuke Development", href: "/dotnetnuke-development" },
      { label: "Legacy System Maintenance", href: "/it-consulting-services" },
      { label: "BizRuleEngine", href: "/biz-rule-engine" },
      { label: "CMS", href: "/cms" },
      { label: "Umrah Booking Solution", href: "/umrah-booking-solution" },
    ],
  },
  {
    label: "Enterprise AI",
    href: "/enterprise-ai",
  },
  {
    label: "Resources",
    href: "/resources/insights",
    children: [
      { label: "Insights / Blog", href: "/resources/insights" },
      { label: "News & Press Release", href: "/news" },
      { label: "Events", href: "/events" },
      { label: "Membership", href: "/membership" },
      { label: "International Projects", href: "/international-projects" },
      { label: "Domestic Projects", href: "/domestic-projects" },
      { label: "International Acceptance", href: "/international-acceptance" },
    ],
  },
  {
    label: "About Us",
    href: "/about",
    children: [
      { label: "About Avani Cimcon", href: "/about" },
      { label: "Management", href: "/management" },
      { label: "Expertise & Experience", href: "/expertise-experience" },
      { label: "ACT Advantage", href: "/advantage" },
      { label: "Value Proposition", href: "/value-proposition" },
      { label: "Partners – Objective", href: "/objective" },
      { label: "Partners – Benefits", href: "/benefits" },
      { label: "Partners Program", href: "/partners-program" },
      { label: "Careers", href: "/careers" },
    ],
  },
];

class NewNavbar extends Component {
  constructor(props) {
    super(props);
    // openIndex tracks which desktop dropdown is open (-1 = none)
    this.state = { mobileOpen: false, openIndex: -1, mobileExpanded: {} };
    this.navRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener("click", this.handleOutsideClick);
    document.addEventListener("keydown", this.handleGlobalKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleOutsideClick);
    document.removeEventListener("keydown", this.handleGlobalKeyDown);
  }

  handleOutsideClick = (e) => {
    if (this.navRef.current && !this.navRef.current.contains(e.target)) {
      this.setState({ openIndex: -1 });
    }
  };

  handleGlobalKeyDown = (e) => {
    if (e.key === "Escape") {
      this.setState({ openIndex: -1 });
    }
  };

  toggleDesktopDropdown = (idx) => {
    this.setState((s) => ({ openIndex: s.openIndex === idx ? -1 : idx }));
  };

  handleDropdownKeyDown = (e, idx) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      this.toggleDesktopDropdown(idx);
    }
  };

  toggleMobile = () => {
    this.setState((s) => ({ mobileOpen: !s.mobileOpen }));
  };

  toggleMobileGroup = (label) => {
    this.setState((s) => ({
      mobileExpanded: {
        ...s.mobileExpanded,
        [label]: !s.mobileExpanded[label],
      },
    }));
  };

  closeMobile = () => {
    this.setState({ mobileOpen: false, mobileExpanded: {} });
  };

  render() {
    const { mobileOpen, openIndex, mobileExpanded } = this.state;
    return (
      <>
      <a className="skip-to-main" href="#main-content">Skip to main content</a>
      <nav className="nav-v2" aria-label="Main navigation" ref={this.navRef}>
        <div className="container">
          <div className="nav-v2-top">
            {/* Logo */}
            <Link to="/" className="nav-v2-logo" aria-label="Avani Cimcon Technologies — Home">
              <img src={Logo} alt="Avani Cimcon Technologies" />
            </Link>

            {/* Desktop nav */}
            <ul className="nav-v2-links" role="menubar">
              {NAV_ITEMS.map((item, idx) => {
                const isOpen = openIndex === idx;
                const dropdownId = `nav-dropdown-${idx}`;
                const hasChildren = !!(item.children && item.children.length);
                return (
                  <li key={item.label} role="none">
                    {hasChildren ? (
                      <button
                        aria-haspopup="menu"
                        aria-expanded={isOpen}
                        aria-controls={dropdownId}
                        onClick={() => this.toggleDesktopDropdown(idx)}
                        onKeyDown={(e) => this.handleDropdownKeyDown(e, idx)}
                      >
                        {item.label}
                        <span className="caret" aria-hidden="true">▾</span>
                      </button>
                    ) : (
                      <Link
                        to={item.href}
                        onClick={() => this.setState({ openIndex: -1 })}
                      >
                        {item.label}
                      </Link>
                    )}
                    {hasChildren ? (
                      <ul
                        id={dropdownId}
                        className={`nav-v2-dropdown${isOpen ? " open" : ""}`}
                        role="menu"
                        aria-label={item.label}
                      >
                        {item.children.map((child) => (
                          <li key={child.href + child.label} role="none">
                            <Link
                              to={child.href}
                              role="menuitem"
                              onClick={() => this.setState({ openIndex: -1 })}
                            >
                              {child.label}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    ) : null}
                  </li>
                );
              })}
              <li role="none">
              <Link to="/contact-us" className="nav-v2-cta" role="menuitem">
                  Talk to Us
              </Link>
            </li>
            </ul>

            {/* Hamburger */}
            <button
              className="nav-v2-hamburger"
              onClick={this.toggleMobile}
              aria-label={mobileOpen ? "Close navigation menu" : "Open navigation menu"}
              aria-expanded={mobileOpen}
              aria-controls="nav-mobile-menu"
            >
              <span /><span /><span />
            </button>
          </div>

          {/* Mobile menu — grouped with expand/collapse per section */}
          <div
            id="nav-mobile-menu"
            className={`nav-v2-mobile-menu${mobileOpen ? " open" : ""}`}
            aria-hidden={!mobileOpen}
          >
            {NAV_ITEMS.map((item) => {
              const groupOpen = !!mobileExpanded[item.label];
              const hasChildren = !!(item.children && item.children.length);
              return (
                <div key={item.label} className="nav-v2-mobile-group">
                  {hasChildren ? (
                    <button
                      className="nav-v2-mobile-group-btn"
                      onClick={() => this.toggleMobileGroup(item.label)}
                      aria-expanded={groupOpen}
                    >
                      {item.label}
                      <span className="caret" aria-hidden="true">{groupOpen ? "▴" : "▾"}</span>
                    </button>
                  ) : (
                    <Link
                      className="nav-v2-mobile-group-btn"
                      to={item.href}
                      onClick={this.closeMobile}
                    >
                      {item.label}
                    </Link>
                  )}
                  {hasChildren && groupOpen && (
                    <ul className="nav-v2-mobile-group-list">
                      {item.children.map((child) => (
                        <li key={child.href + child.label}>
                          <Link to={child.href} onClick={this.closeMobile}>
                            {child.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              );
            })}
            <Link
              to="/contact-us"
              className="nav-v2-mobile-cta"
              onClick={this.closeMobile}
            >
              Talk to Us →
            </Link>
          </div>

          {/* SEO tagline bar */}
          <div className="nav-v2-tagline" aria-label="Company tagline">
            Delivering cutting-edge software solutions since 1992
          </div>
        </div>
      </nav>
      </>
    );
  }
}

export default NewNavbar;
